import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';

export const ssoConfigQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['ssoConfig', organizationId],
    queryFn: async () =>
      (
        await api.get<{
          enforced: boolean;
          domains: {
            id: string;
            emailDomain: string;
            entraTenantId: string;
            verifiedAt: string | null;
            autoProvision: boolean;
          }[];
        }>(`v1/organizations/${organizationId}/sso`)
      ).data,
  });
